import React from 'react'
import Skeletons from '@/custom/components/Skeletons'

function DotBlinkLoader() {
    return <div className="dotLoader"></div>
}

export default DotBlinkLoader
